module.exports = __webpack_public_path__ + "specificItem.svg?70e80d944dceb5c3fbef28e0842586b3";